<div class="view-container">
  <div class="products">
    <mat-card>
      <mat-card-content>
        <div class="filter" fxLayoutAlign="center center">
          <mat-form-field class="accent">
            <mat-label>Search</mat-label>
            <input matInput type="text"
              [(ngModel)]="searchTerm"
              (keyup.enter)="loadProducts()"
              (keyup.esc)="searchTerm=''; loadProducts()"
              name="searchTerm" placeholder="Search Description or SKU">
            <button type="reset" mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div fxLayout="row" fxLayoutGap="15px">
            <button mat-stroked-button color="basic" (click)="onCancelClick()">
              <mat-icon>clear</mat-icon> Cancel
            </button>
            <button mat-flat-button color="warn" (click)="onPurgeImportClick()">
              <mat-icon>delete</mat-icon> Purge
            </button>
            <button mat-flat-button color="primary" (click)="onImportClick()">
              <mat-icon>done</mat-icon> Import
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <div class="search-status" *ngIf="!productsDataSource.data?.length && !loading">
        No products match that search criteria
      </div>
      <div class="search-status" *ngIf="!productsDataSource.data?.length && loading && searchTerm">
        Searching products for <em>"{{ searchTerm }}"...</em>
      </div>
      <div class="search-status" *ngIf="!productsDataSource.data?.length && loading && !searchTerm">
        Searching products...
      </div>
      <div [hidden]="!productsDataSource.data?.length">
        <table mat-table [dataSource]="productsDataSource" multiTemplateDataRows>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let item"> {{ item.description }} </td>
          </ng-container>
          <ng-container matColumnDef="sku">
            <th mat-header-cell *matHeaderCellDef> SKU </th>
            <td mat-cell *matCellDef="let item"> {{ item.sku }} </td>
          </ng-container>
          <ng-container matColumnDef="displaySku">
            <th mat-header-cell *matHeaderCellDef> Display SKU </th>
            <td mat-cell *matCellDef="let item"> {{ item.displaySku }} </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let item"> {{ item.type }} </td>
          </ng-container>
          <ng-container matColumnDef="brand">
            <th mat-header-cell *matHeaderCellDef> Brand </th>
            <td mat-cell *matCellDef="let item"> {{ item.brand }} </td>
          </ng-container>
          <ng-container matColumnDef="errors">
            <td mat-cell *matCellDef="let item" [attr.colspan]="viewControls.displayedColumns.length">
              <mat-error *ngFor="let error of item.errors">{{error.error}}</mat-error>
            </td>
          </ng-container>
          <ng-container matColumnDef="disabled">
            <th mat-header-cell *matHeaderCellDef> Enabled </th>
            <td mat-cell *matCellDef="let item"> {{ item.disabled ? "No" : "Yes" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="import">
            <th mat-header-cell *matHeaderCellDef>Import</th>
            <td mat-cell *matCellDef="let item">
              <mat-checkbox [(ngModel)]="item.import" *ngIf="(!item?.errors?.length)">
              </mat-checkbox>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="viewControls.displayedColumns"></tr>
          <ng-container>
            <tr mat-row class="element-row" *matRowDef="let item; columns: viewControls.displayedColumns;" [ngClass]="!!item?.errors?.length ? 'validation-error': ''"> </tr>
          </ng-container>
          <ng-container>
            <tr mat-row class="element-row" *matRowDef="let item; columns: ['errors'];" [hidden]="!item?.errors?.length"></tr>
          </ng-container>
        </table>
        <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
          [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
          (page)="onPageChange($event)">
        </mat-paginator>
      </div>
    </mat-card>
  </div>
</div>
